import { BaseViewStore} from 'core/stores';
import { action, observable } from "mobx";

class FacilityOrderTemplateItemNewFlowActivatePatientModalStore extends BaseViewStore {
    @observable accessor disabled = false;
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.patient = this.modalParams.data.patient;
        this.setPatientStatus = this.modalParams.data.setPatientStatus;
    }

    @action.bound
    async activatePatient() {
        this.disabled = true;
        try {
            await this.modalParams.data.setInactiveOption();
            if(this.setPatientStatus)
                await this.modalParams.data.setPatientStatus();
            this.modalParams.close();
        }
        catch (err) {
            return this.onUpdateError(err);
        }
        this.disabled = false;
    }
}

export default FacilityOrderTemplateItemNewFlowActivatePatientModalStore;
